import React from 'react';

const ContactCard = ({ contact }) => {
  return (
    <div className="contact-card">
      <h3>
        <i className={contact.icon}></i> {contact.title}
      </h3>
      <p dangerouslySetInnerHTML={{ __html: contact.content }}></p>
    </div>
  );
};

export default ContactCard;